// VideoSection.js
import React, { useState, useEffect } from "react";
import VideoCard from './VideoCard';
import "./VideoSection.css"
import "aos/dist/aos.css";
import AOS from "aos";

const videoData = [
  {
  
      title: "CSE 3rd Sem One-Shot | AKTU",
      description: "Complete syllabus explained in one video for AKTU 3rd sem CSE.",
      link: "https://www.youtube.com/watch?v=tPPogb-4u_I",
      thumbnail: "https://img.youtube.com/vi/tPPogb-4u_I/hqdefault.jpg"

    
  },
  {
    title: "COA MOST IMPORTANT TOPICS FOR BTECH 2ND YEAR AKTU STUDENTS!!!!",
      description: "Functional units of digital system,bus architecture,types of busesbus arbitration,general registers organization",
      link: "https://www.youtube.com/watch?v=QGEDXOzKul8&ab_channel=LePic",
      thumbnail: "https://i.ytimg.com/vi/QGEDXOzKul8/hqdefault.jpg",
  },
  {
    title: "DBMS COMPLETE SYLLABUS ONE SHOT REVISION AKTU 🔥🔥💯",
      description: "Introduction to DBMS: Overview, Data Models, ER Diagrams,Relational Model & SQL: Integrity Constraints, Joins, Queries",
      link: "https://www.youtube.com/watch?v=mLFx0u7K7Ns&ab_channel=LePic",
      thumbnail: "https://i.ytimg.com/vi/mLFx0u7K7Ns/hqdefault.jpg",
  },
  {
    title: "DAA UNIT-01 ONE SHOT AKTU 3RD YEAR EXAMs 🔥🔥 💯",
    description: "Design and analysis of algorithm aktu",
    link: "https://www.youtube.com/watch?v=LcJSt92nx70&ab_channel=LePic",
    thumbnail: "https://i.ytimg.com/vi/whN1gaHGHUg/hqdefault.jpg",
  },
];

const VideoSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    
    <div className="video-section" data-aos="fade-right">
      <h2>Our Featured Videos</h2>
      <div className="video-grid">
        {videoData.map((video, index) => (
          <VideoCard
            key={index}
            title={video.title}
            description={video.description}
            link={video.link}
            thumbnail={video.thumbnail}
          />
        ))}
      </div>
    </div>
  );
};

export default VideoSection;
